import apiFetch from '../../apiFetch'

export default function (token, countryId) {
  const queryParamsArray = [
    `countryId=${countryId}`
  ]
  const queryParams = queryParamsArray.reduce(
    (result, query, idx) => result + (query ? (result ? `&${query}` : `?${query}`) : '')
    , ''
  )
  return apiFetch({ endPoint: `Entity/GetAllStates${queryParams}`, method: 'GET', token: token })
}
